import { IntlFormatters } from "react-intl";
import defineMessages from "./defineMessages";
import routing from "../../front/routing";
import store from "store";

const messages = defineMessages({
    solveNormally: {
        id: "exercise.solve.normally",
    },
    solveAsExperience: {
        id: "exercise.solve.solveAsExperience",
    },

});

export const getPlayItems = (formatMessage: IntlFormatters["formatMessage"], { publicView, planId }: { planId: string, publicView: boolean }) => {
    const linkPrefix = `${publicView ? routing.publicPlay : routing.play}/${planId}`;
    
    const onClick = () => {
        store.set("play-plan-id", planId);
    }
    return [
        {
            label: formatMessage(messages.solveNormally),
            link: `/${linkPrefix}`,
            onClick,
        },
        {
            label: formatMessage(messages.solveAsExperience),
            link: `/${linkPrefix}/${routing.experience}`,
            onClick,
        },
    ]
}